<div class="p-l-1vw p-t-1vw p-r-1vw " *ngIf="(!spinnerFlag)">
  <mat-grid-list cols="2" rowHeight="70px">
    <mat-grid-tile flex-start flex-align-top class="grid-spacing">
      <h1 class="page-title">
        <div class="w-px-500">
          {{'apiImportParams' | translate}}
        </div>
      </h1>
    </mat-grid-tile>
    <mat-grid-tile flex-end flex-align-top class="grid-spacing">
    </mat-grid-tile>
  </mat-grid-list>

  <div class="description-container">
    {{('apiImportParamsDescription') | translate}}
  </div>

  <mat-grid-list cols="12" rowHeight="450px" class="m-l-10">
    <mat-grid-tile flex-start flex-align-top colspan="10">
      <div class="card-shadow outer-container">
        <div *ngFor="let param of apiImportParams">
          <div>
            <p class="fw-500">{{param.paramTypeTranslationKey | translate}}</p>
          </div>
          <div>
            <table class="api-import-param-table">
              <tr>
                <td class="w-160" *ngFor="let paramOption of param.paramOptions">
                  <mat-field appearance="outline" class="form-field ">
                    <mat-checkbox [checked]="paramOption.selected" (change)="checkedChanged(paramOption)">
                      {{ paramOption.optionTranslationKey | translate }}
                    </mat-checkbox>
                  </mat-field>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="m-t-80 m-b-20">
          <button mat-raised-button color="basic" class="m-l-10" (click)="revertChanges()">{{'stop' |
            translate}}</button>
          <button mat-raised-button class="custom-button m-l-20" [disabled]="disableIfNoValueChanged()"
            (click)="saveApiImportParams()"> {{'save' | translate}}</button>
        </div>
      </div>
    </mat-grid-tile>
  </mat-grid-list>



</div>
<div class="spinner" *ngIf="spinnerFlag">
  <mat-spinner class="custom-field" mode="indeterminate"></mat-spinner>
</div>